import React from "react";
import ReactStars from "react-rating-stars-component";
import { ReactComponent as StarIcon } from "../../../asset/icons/starIcon.svg";
import { ReactComponent as EmptyStarIcon } from "../../../asset/icons/emptyStarIcon.svg";
import { ReactComponent as Calender } from "../../../asset/icons/calender_gray_s.svg";
import ex_img from "../../../asset/image/ex_img_3.png";
import { ReactComponent as Logo } from "../../../asset/icons/amazon_logo_wob_lg.svg";
import { ReactComponent as Share } from "../../../asset/icons/share_white.svg";
import { ReactComponent as Bookmark } from "../../../asset/icons/bookmark_white.svg";
import { ReactComponent as Person } from "../../../asset/icons/person_white.svg";

export default function ProductCard() {
    return (
        <div className="card-main">
            <div className="product-card-container">
                <div
                    className="card-header"
                    style={{ backgroundImage: `url(${ex_img})` }}
                >
                    <div className="card-buttons">
                        <button className="sm-button">
                            <Person />
                        </button>
                        <button className="sm-button">
                            <Share />
                        </button>
                        <button className="sm-button">
                            <Bookmark />
                        </button>
                    </div>
                    <div className="logo-cv">
                        <Logo />
                    </div>
                </div>
                <div className="card-content">
                    <h2>نام محصول یا خدمت</h2>
                    <div className="rating-stars" dir="ltr">
                        <ReactStars
                            count={5}
                            size={10}
                            activeColor="#FEB730"
                            filledIcon={<StarIcon />}
                            emptyIcon={<EmptyStarIcon />}
                        />
                    </div>
                    <p>
                        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت
                        چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون
                        بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و
                        برای
                    </p>
                    <div className="card-date">
                        <div>
                            <Calender />
                            <div>4/25/2021</div>
                        </div>
                        <button className="sm-button"></button>
                    </div>
                </div>
            </div>
        </div>
    );
}
